import { Field, Value } from '../../../schemas/entity';
import { StringViewer } from './StringViewer';
import { NumberViewer } from './NumberViewer';
import { BooleanViewer } from './BooleanViewer';
import { PickListViewer } from './PickListViewer';
import { DateTimeViewer, type DateTimeValue } from './DateTimeViewer';
import { PromptViewer, type PromptValue } from './PromptViewer';
import { ReferenceValue, ReferenceViewer } from './ReferenceViewer';
import { ObjectViewer } from './ObjectViewer';
import { NullViewer } from './NullViewer';
import { YamlViewer } from './YamlViewer';
import { ConnectResourceViewer } from './ConnectResourceViewer';
import { ConnectResourceValue, LegacyConnectResourceValue } from '../../../common/connect-resource';
import { CopyButton } from '@@/ui/primitives';

interface FieldViewerProps {
  value: Value | null | undefined;
  field: Field;
  showFullContent: boolean;
}

export function FieldViewer({ value, field, showFullContent }: FieldViewerProps) {
  if (value === null || value === undefined) {
    return <NullViewer value={value} />;
  }

  switch (field.definition.type) {
    case 'number':
      return <NumberViewer value={typeof value === 'number' ? value : 0} />;
    case 'boolean':
      return <BooleanViewer value={typeof value === 'boolean' ? value : false} />;
    case 'picklist':
      return <PickListViewer value={typeof value === 'string' ? value : ''} />;
    case 'date_time':
      return <DateTimeViewer value={value as unknown as DateTimeValue} />;
    case 'prompt':
      return <PromptViewer value={value as unknown as PromptValue} full={showFullContent} />;
    case 'reference':
      return <ReferenceViewer value={value as unknown as ReferenceValue} />;
    case 'object':
      return <ObjectViewer value={value} full={showFullContent} />;
    case 'yaml':
      return <YamlViewer value={value} full={showFullContent} />;
    case 'connect_resource':
      return <ConnectResourceViewer value={value as unknown as ConnectResourceValue | LegacyConnectResourceValue} />;
    case 'string':
      return (
        <div className='flex flex-row items-center'>
          <StringViewer value={typeof value === 'string' ? value : String(value)} />
          {field.primary && <CopyButton content={typeof value === 'string' ? value : String(value)} />}
        </div>
      );
    default:
      return <StringViewer value={typeof value === 'string' ? value : String(value)} />;
  }
}
